import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetSingleQuizathon } from "../../../services/quizathon";
import {
  getSingleQuizathonFailure,
  getSingleQuizathonStart,
  getSingleQuizathonSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* getSingleQuizathon({ payload }) {
  const response = yield call(httpGetSingleQuizathon, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getSingleQuizathonSuccess(raw));
  } else {
    yield put(getSingleQuizathonFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetSingleQuizathon() {
  yield takeLatest(getSingleQuizathonStart.type, getSingleQuizathon);
}
